import { expected, isDefined } from '@aloft/toolkit-shared';

import { useParams } from 'react-router';

import { useGetTkv2PublicRecordAPI } from '../../../hooks/api/schema-hooks/useGetTkv2PublicRecordAPI.ts';
import { useParsedActiveID } from './useParsedActiveID.ts';

export function usePublicRecordForListing() {
  const { orderId: orderID } = useParams();
  const { address } = useParsedActiveID();

  const publicRecord = useGetTkv2PublicRecordAPI(
    {
      pathParams: { orderID: expected(orderID) },
      queryParams: address,
    },
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: isDefined(address),
    },
  );

  return isDefined(address) ? publicRecord : { isError: true, isLoading: false, data: undefined };
}
